import { render, staticRenderFns } from "./BridgeYear.vue?vue&type=template&id=09852f7e&scoped=true&"
import script from "./BridgeYear.vue?vue&type=script&lang=js&"
export * from "./BridgeYear.vue?vue&type=script&lang=js&"
import style0 from "./BridgeYear.vue?vue&type=style&index=0&id=09852f7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09852f7e",
  null
  
)

export default component.exports